import type { SVGProps } from 'react';

const SvgCheckMarkBullet = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" {...props}>
    <path
      fill={props.color}
      fillRule="evenodd"
      d="M16 32c8.84 0 16-7.16 16-16S24.84 0 16 0 0 7.16 0 16s7.16 16 16 16Zm7.41-18.59c.78-.78.78-2.05 0-2.83-.78-.78-2.05-.78-2.83 0l-6.59 6.59-2.59-2.59c-.78-.78-2.05-.78-2.83 0-.78.78-.78 2.05 0 2.83l4 4c.78.78 2.05.78 2.83 0l8-8Z"
    />
  </svg>
);

export default SvgCheckMarkBullet;
